// src/services/search.adapter.js
import { search as realSearch } from '../../functions/basics/chat'

/** Converte ISO -> "x dias/horas/minutos atrás" */
function timeAgo(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  const diff = Date.now() - d.getTime()
  const m = Math.floor(diff / 60000)
  const h = Math.floor(m / 60)
  const dys = Math.floor(h / 24)
  if (dys) return `${dys} dia${dys > 1 ? 's' : ''} atrás`
  if (h) return `${h} hora${h > 1 ? 's' : ''} atrás`
  if (m) return `${m} minuto${m > 1 ? 's' : ''} atrás`
  return 'agora mesmo'
}

/** Normaliza exatamente para o shape esperado pela view */
function normalizeResponse(raw) {
  const contactsRaw = Array.isArray(raw?.contacts) ? raw.contacts : []
  const convsRaw = Array.isArray(raw?.conversations) ? raw.conversations : []
  const msgsRaw = Array.isArray(raw?.messages) ? raw.messages : []

  // Contacts
  const contacts = contactsRaw.map((c, i) => ({
    id: c.id ?? i,
    name: c.name ?? c.nome ?? '',
    phone: c.phone ?? '',
    atendimentos: c.atendimentos ?? [], // PRESERVAR os atendimentos!
  }))

  // Conversations (usar o id do atendimento SEM mudar o nome do campo)
  const conversations = convsRaw.map((c, i) => ({
    id: c.id ?? c.atendimentoId ?? i, // << id do atendimento
    chatId: c.chatId ?? null,
    status: c.status ?? null,
    clienteId: c.clienteId ?? null,
    clienteNome: c.clienteNome ?? null,
    title: c.title ?? (c.clienteNome ? `Atendimento de ${c.clienteNome}` : `Atendimento #${c.id ?? i}`),
    lastMessageAt: c.lastMessageAt ?? null,
  }))

  // Messages (PRESERVAR atendimentoId!)
  const messages = msgsRaw.map((m, i) => ({
    id: m.id ?? i,
    atendimentoId: m.atendimentoId ?? m.atendimento_id ?? null, // << necessário pro modal
    channel: m.channel ?? 'chat',
    author: m.author ?? '—',
    body: m.body ?? '',
    createdAt: m.createdAt ?? null,
    age: timeAgo(m.createdAt ?? null),
    clienteId: m.clienteId ?? null,
    clienteNome: m.clienteNome ?? null,
  }))

  return { contacts, conversations, messages }
}

export async function search(uuid, query) {
  if (!query || query.length < 3) {
    return { contacts: [], conversations: [], messages: [] }
  }
  const raw = await realSearch(uuid, query)
  return normalizeResponse(raw)
}
